import React from 'react';
import { hydrate, render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { getAnalyticsOptions, ThemisAnalytics } from '@legalshield/frontend-analytics';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { App } from './components/App/App';
import envConfig from './config';

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: envConfig.launchDarklyConfig.clientSideID,
    reactOptions: {
      sendEventsOnFlagRead: true,
    },
    options: {
      streaming: true,
      sendEventsOnlyForVariation: true,
    },
  });

  const root = document.getElementById('root');
  let renderMethod;
  if (root && root.innerHTML !== '') {
    renderMethod = hydrate;
  } else {
    renderMethod = render;
  }

  const themisAnalytics = new ThemisAnalytics(getAnalyticsOptions(window?.location?.hostname, envConfig.getGtmVars()));

  void themisAnalytics.initialize();
  const queryClient = new QueryClient();

  renderMethod(
    <React.StrictMode>
      <BrowserRouter>
        <LDProvider>
          <QueryClientProvider client={queryClient}>
            <App />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </LDProvider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
  );
})();
